let Roles = [
  { name: "Admin", id: "f39b245f-73bf-4e78-8a93-a5ecc284000f" },
  { name: "Manager", id: "c4fa3a2a-2d4c-4623-96ba-de5389dd116f" },
  { name: "Serwis", id: "a4ac85fa-1840-4f47-899a-69e87f57f923" },
  { name: "Pracownik", id: "41860b99-25bc-4ca3-af42-b4d9c16a0330" },
  { name: "Kierowca", id: "2fa7c834-8bc0-4e6d-b9bb-23e4852dee24" }
]

let DateFormat = {
  type: 'date', format: 'dd.MM.yyyy'
}

let GridConfig = {
  PageSettings: { pageSize: 200 },
  AllowPaging: true,
  EnableStickyHeader: true,
  Width: "100%",
  Height: "100%",
  FilterSettings: {
    type: 'FilterBar',
    operator: 'contains',
    ignoreAccent: true,
    showFilterBarOperator: true,
    //operators: {
    //  stringOperator: [
    //    { value: 'contains', text: 'Zawiera' },
    //    { value: 'startsWith', text: 'Zaczyna sie od' },
    //    { value: 'endsWith', text: 'Kończy się na' },
    //    { value: 'equal', text: 'Równa się' }
    //  ],
    //  dateOperator: [
    //    { value: 'greaterThanOrEqual', text: 'Większa bądź równa niż' },
    //    { value: 'lessThanOrEqual', text: 'Mniejsza bądż równa niż' },
    //  ],
    //},
  },
  Filter : { operator: "contains" }
}

let GridFilterOptionsMenuData = {
  type: 'Menu',
  operators: {
    stringOperator: [
      { value: 'contains', text: 'Zawiera' },
      { value: 'startsWith', text: 'Zaczyna sie od' },
      { value: 'endsWith', text: 'Kończy się na' },
      { value: 'equal', text: 'Równa się' }
    ],
    dateOperator: [
      { value: 'greaterThanOrEqual', text: 'Większa bądź równa niż' },
      { value: 'lessThanOrEqual', text: 'Mniejsza bądż równa niż' },
    ],
  },
}

function GridFilterOptionsMenu() {
  return JSON.parse(JSON.stringify(GridFilterOptionsMenuData));
}

let GridIds = [
  "Grid", "GridPMAll", "GridFirstAll", "GridFirstAll", "GridPMW", "GridRB", "GridRP", "GridRW", "GridRWA2", "GridRWA", "GridZW", "gHistoria", "gFaktury", "gUslugi", "GridS", "GridO",
  "GridZW","GridZM", "GridZHW", "GridZHWOsprzet", "gridTransporty", "GridPytania", "GridSzablony", 
  "GridZadania", "GridZadaniaM"
]

let ZleceniaTypyData = [{ value: 'M', text: "Serwis mobilny" }, { value: 'S', text: "Zlecenie warsztatowe" }]

let CeleTypyData = [{ value: 'Gwarancja', text: "Gwarancja" }, { value: 'Płatna', text: "Płatna" }, { value: 'Przegląd okresowy', text: "Przegląd okresowy" }]

let RodzajeDostawData = [{ value: 'Sprzedaż', text: "Sprzedaż" }, { value: 'Wynajem', text: "Wynajem" }, { value: 'Podstawienie', text: "Podstawienie" }, { value: 'Naprawa', text: "Naprawa" }, { value: 'Testy', text: "Testy" }]

let TypyDokumentKsiegowyData = [{ value: 'RW', text: "RW" }, { value: 'WZ', text: "WZ" }, { value: 'GW', text: "GW" }]

let TNTypyData = [{ value: 'T', text: "Tak" }, { value: 'N', text: "Nie" }]
function ZleceniaTypy() {
  return JSON.parse(JSON.stringify(ZleceniaTypyData));
}
function CeleTypy() {
  return JSON.parse(JSON.stringify(CeleTypyData));
}

function RodzajeDostaw() {
  return JSON.parse(JSON.stringify(RodzajeDostawData));
}

function TNTypy() {
  return JSON.parse(JSON.stringify(TNTypyData));
}

function TypyDokumentKsiegowy() {
  return JSON.parse(JSON.stringify(TypyDokumentKsiegowyData));
}

function ResetGridsData() {
  for (let i = 0; i < GridIds.length; i++) {
    let gname = "grid" + GridIds[i];
    console.log("Czyszczę " + gname);
    let el = document.getElementById(GridIds[i]);
    let [ej2] = el?.ej2_instances || [];
    if (ej2) {
      ej2.enablePersistence = false;
      window.localStorage.setItem(gname, "");
      ej2.destroy();
      console.log("Czyszczę ex " + gname);
    } else {
      window.localStorage.setItem(gname, "");
    }
  }
}

function getTaskRoute(id, typ) {
 
  let actualId = id;
  if (typeof id === 'string' && id.includes('_')) {
    const parts = id.split('_');
    if (parts.length === 2) {
      actualId = parts[1];
    }
  }
  
  if (typ == null) {
    return '/jmp/MojeZadania/';
  }
  
  switch(typ) {
    case 10:
      return '/jmp/transport/form/' + actualId;
    case 21:
      return '/jmp/zleceniaWarsztatowe/serwisMobilny/' + actualId;
    case 22:
      return '/jmp/zleceniaWarsztatowe/serwisStacjonarny/' + actualId;
    default:
      console.log('Unknown type');
      return '/jmp/MojeZadania/';
  }
}

export { Roles, DateFormat, GridConfig, GridFilterOptionsMenu, ResetGridsData, ZleceniaTypy, CeleTypy, TNTypy, TypyDokumentKsiegowy, RodzajeDostaw, getTaskRoute };
